import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import ProjectOnboard from "./ProjectOnboard";

const ProjectOnboardGuard = (props) => {
    const history = useHistory();
    const isEditMode = Boolean(props.match?.params?.id);
    const hasProjectType = props.location?.state?.projectType;

    useEffect(() => {
        if (!isEditMode && !hasProjectType) {
            history.push("/projects/select-type");
        }
    }, [history, isEditMode, hasProjectType]);

    if (!isEditMode && !hasProjectType) {
        return null;
    }

    return <ProjectOnboard {...props} />;
};

export default ProjectOnboardGuard;